export function createElementsScrollPositions() {
  var scrollPositionsByElement = new WeakMap();
  return {
    set: function set(element, scrollPositions) {
      if (element === document && !document.scrollingElement) {
        // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
        // in some cases scrolling elements can not be defined, we don't support those for now
        return;
      }
      scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
    },
    get: function get(element) {
      return scrollPositionsByElement.get(element);
    },
    has: function has(element) {
      return scrollPositionsByElement.has(element);
    }
  };
}